import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'
import { IdGen } from 'utils'

import * as RequerimientoService from 'services/requerimiento.service'
import * as Sections from './sections'

const portletBreadcrumbs = [
  { name: 'Requerimientos', path: `/${CodigosTransaccionesConstant.REQUERIMIENTOS_LISTA}` },
  { name: 'Evaluacion' }
]

const RequerimientoNuevoActualizar = () => {
  const __zariContext = React.useContext(ZariContext)

  const detallesRef = React.useRef({})
  const [__keySection, setKeySection] = React.useState(IdGen.newId())
  const [detalles, setDetalles] = React.useState([])

  const [desde, setDesde] = React.useState('')
  const [hasta, setHasta] = React.useState('')

  const cargarTabla = React.useCallback(() => {
    const params = {
      desde: desde || '',
      hasta: hasta || ''
    }

    __zariContext.loader.open('Obteniendo requerimientos pendientes ')
    RequerimientoService.obtenerAprobadasAsDetallesPendientes(params)
      .then(({ data }) => {
        setDetalles(data)
        setKeySection(IdGen.newId())
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, desde, hasta])

  React.useEffect(() => {
    const t = setTimeout(() => {
      cargarTabla()
    }, 250)
    return () => clearTimeout(t)
  }, [desde, hasta, cargarTabla])

  const clickGuardar = React.useCallback(() => {
    __zariContext.loader.open('Guardando datos de evaluación')

    const detallesTrabajados = detallesRef.current.getData()
    const detallesValidos = detallesTrabajados.filter(x => x.flagOrdenCompra || x.flagAlmacen)
    const detallesNormalizados = detallesValidos.map(x => {
      return {
        _id: x._id,
        precio: x.precio ? parseFloat(x.precio) : null,
        flagAlmacen: x.flagAlmacen,
        flagOrdenCompra: x.flagOrdenCompra,
        _idSocio: x._idSocio
      }
    })

    RequerimientoService.actualizarxIdsDetallesAsEvaluacion(detallesNormalizados)
      .then(() => {
        __zariContext.toast('success', 'Datos de evaluación guardados satisfactoriamente.')
        cargarTabla()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, cargarTabla])

  React.useEffect(() => {
    cargarTabla()
  }, [])

  return (
    <Portlet>
      <Portlet.Header title='Requerimientos' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Row style={{ marginBottom: '0.75rem' }}>
          <Col md={6} />

          <Col md={3}>
            <Form.Group>
              <Form.Label text='DESDE' htmlFor='date-desde' md={4} alignRightAt='md' />
              <Col md={8}>
                <Form.InputDate id='date-desde' value={desde} onChange={e => setDesde(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>

          <Col md={3}>
            <Form.Group>
              <Form.Label text='HASTA' htmlFor='date-hasta' md={4} alignRightAt='md' />
              <Col md={8}>
                <Form.InputDate id='date-hasta' value={hasta} onChange={e => setHasta(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>

        <Sections.DetallesSection key={__keySection} innerDetalles={detalles} detallesRef={detallesRef} />

        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickGuardar}>Guardar</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(RequerimientoNuevoActualizar)
